<template>
    <div class="datagrid-wrapper">
        <div class="row">
            <div class="col-md-12">
                <table class="datagrid table">
                    <thead>
                    <tr>
                        <th v-for="header in table_headers">
                            <h4>{{ header }}</h4>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="!access.data">
                        <td :colspan="table_headers.length"><span class="spinner anim-spin"></span></td>
                    </tr>
                    <tr v-else-if="!access.data.length">
                        <td :colspan="table_headers.length">No results</td>
                    </tr>
                    <tr v-for="item in access.data" v-bind:key="item.id">
                        <td v-for="column in table_columns">
                            <div v-if="column === 'inventory_name'">
                                <a :href="`/centre/inventory/${item.id}`">{{ item[column] }}</a>
                            </div>
                            <div v-else-if="column === 'time_period'" class="text-nowrap">
                                <span>{{ $formatDate(item.start_date, user_date_format) }} / {{ $formatDate(item.end_date, user_date_format) }}</span>
                            </div>
                            <div v-else-if="column === 'hours'" class="text-nowrap">
                                <span>{{ item[column] }}</span>
                            </div>
                            <div v-else-if="column === 'centre_name'">{{ item[column] }}</div>
                            <div v-else v-html="item[column]"></div>
                        </td>
                    </tr>
                    </tbody>
                    <tfoot>
                    <tr>
                        <td colspan="3">
                            <pagination :data="access" :limit=3 @pagination-change-page="getAccessItems">
                                <template #prev-nav>
                                    <span>&lt; Previous</span>
                                </template>
                                <template #next-nav>
                                    <span>Next &gt;</span>
                                </template>
                            </pagination>
                        </td>
                    </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: "BusinessLoungeAccessDataTable",
    props: {
        api_endpoint: {
            type: String,
        },
        user_date_format: {
            type: String,
        },
        table_headers: {
            type: Array,
        },
        table_columns: {
            type: Array,
        },
    },
    data() {
        return {
            access: {},
            paginate: 10,
        }
    },
    watch: {
        paginate: function (value) {
            this.getAccessItems();
        },
        search: function search(value) {
            this.getAccessItems()
        },
    },
    methods: {
        getAccessItems(page = 1) {
            axios.get(this.api_endpoint, {
                params: {
                    page,
                    paginate: this.paginate,
                }
            })
                .then(response => {
                    this.access = response.data;
                });
        }
    },
    mounted() {
        this.getAccessItems();
    }
}
</script>
